import MaterialTable from 'material-table';
import React, { Component } from 'react';
import { forwardRef } from 'react';
import { Card, Dimmer } from "tabler-react";

import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Search from '@material-ui/icons/Search';

class TablaResultados extends Component {
  constructor(props) {
    super(props);
    this.state = ({data: [], alumnosTabla: [], isLoading: true});
  }

  componentDidUpdate = async (prevProps, prevState) => {
    if (prevProps !== this.props) {
      await this.setState({data: this.props});
      this.setTableData();
    }
  }

  componentDidMount = async () => {
    await this.setState({data: this.props});
  }

  setTableData () {
    const docenteInfo = JSON.parse(localStorage.getItem('profile'));
    let alumnosParaTabla = [];
    for (let index in this.state.data.alumnos) {
      if (this.props.curso === this.state.data.alumnos[index].cursoNombre && this.props.data.data.curso.cursosId === this.state.data.alumnos[index].cursoId ) {
        alumnosParaTabla.push({ 
          matricula: this.state.data.alumnos[index].matricula, 
          id: this.state.data.alumnos[index].id, 
          url_id: 'https://'+this.props.nivel+'.ieu.edu.mx/', 
          nombres: this.state.data.alumnos[index].nombres, 
          apellidos: this.state.data.alumnos[index].apellidos, 
          correo: this.state.data.alumnos[index].email, 
          actividad: 'Actividad de Aprendizaje 3. Vulnerabilidad de las empresas', 
          status: 'Enviada' 
        });
      }
    }

    this.setState({alumnosTabla: alumnosParaTabla});
    let submits = [];
  
    if (this.state.data.data.submissionsState.length !== 0) {
      for (const alumnosInfo of  this.state.alumnosTabla) {
        for (const alumnosNotGrade of this.props.data.submissionsState.alumnosNotGrade) {
          if(alumnosInfo.id == alumnosNotGrade.id){
            for (const actividades of this.state.data.data.submissionsState.actividades.assigns) {
              if(actividades.id == alumnosNotGrade.idAssigment){
                submits.push({
                  actividadId: actividades.id, 
                  // matricula: alumnosInfo.matricula,
                  id: alumnosInfo.id, 
                  status: 'No Calificada'
                });
              }
            }
          }
        }
      }
    }

    for (let indexActividad in this.state.data.data.submissionsState.submissions) {
      for (let indexSubmissions in this.state.data.data.submissionsState.submissions[indexActividad].data.submissions.assignments[0].submissions) {
        submits.push({
          actividadId: this.state.data.data.submissionsState.submissions[indexActividad].data.submissions.assignments[0].assignmentid, 
          id: this.state.data.data.submissionsState.submissions[indexActividad].data.submissions.assignments[0].submissions[indexSubmissions].userid, 
          status: this.state.data.data.submissionsState.submissions[indexActividad].data.submissions.assignments[0].submissions[indexSubmissions].status
        });
      }
    }
        
    let alumnos = [];
    for (let indexSubmissions in submits) {
      for (let indexAlumnos in this.state.alumnosTabla) {
        if (this.state.alumnosTabla[indexAlumnos].id === submits[indexSubmissions].id) {
          let estatusESP = '';
          if (submits[indexSubmissions].status === 'submitted') {
            estatusESP = 'Enviada';
            alumnos.push({ 
              id: this.state.alumnosTabla[indexAlumnos].matricula, 
              idMoodle: this.state.alumnosTabla[indexAlumnos].id,
              nombres: this.state.alumnosTabla[indexAlumnos].nombres, 
              apellidos: this.state.alumnosTabla[indexAlumnos].apellidos, 
              correo: this.state.alumnosTabla[indexAlumnos].correo, 
              actividad: submits[indexSubmissions].actividadId, 
              status: estatusESP 
            });
          }
          if (submits[indexSubmissions].status === 'No Calificada') {
            estatusESP = 'No Calificada';
            alumnos.push({ 
              id: this.state.alumnosTabla[indexAlumnos].matricula, 
              idMoodle: this.state.alumnosTabla[indexAlumnos].id,
              nombres: this.state.alumnosTabla[indexAlumnos].nombres, 
              apellidos: this.state.alumnosTabla[indexAlumnos].apellidos, 
              correo: this.state.alumnosTabla[indexAlumnos].correo, 
              actividad: submits[indexSubmissions].actividadId, 
              status: estatusESP 
            });
          }
        } 
      }
    }
    
    if(this.state.data.data.submissionsState.length != 0){
      for (const actividades of this.state.data.data.submissionsState.actividades.assigns) {
        for (const alumnosTabla of this.state.alumnosTabla) {
          let band = true
          for (const alumnosInfo of alumnos) {
            if( actividades.id == alumnosInfo.actividad && alumnosTabla.id == alumnosInfo.idMoodle ){
              band = false
            }
          }
          if (band) {
            alumnos.push({ 
              id: alumnosTabla.matricula, 
              idMoodle: alumnosTabla.id,
              nombres: alumnosTabla.nombres, 
              apellidos: alumnosTabla.apellidos, 
              correo: alumnosTabla.correo, 
              actividad: actividades.id, 
              status: 'No Enviada' 
            });
          }
          
        }
      }
    }
    if (this.state.data.data.submissionsState.length !== 0) { 
      let count = 1;
      for (let indexActividad in this.state.data.data.submissionsState.actividades.assigns) {
        for (let indexAlumnos in alumnos) {
          if (alumnos[indexAlumnos].actividad === this.state.data.data.submissionsState.actividades.assigns[indexActividad].id) {
            alumnos[indexAlumnos].actividadName = 'actividad_'+count;
            alumnos[indexAlumnos].actividad = this.state.data.data.submissionsState.actividades.assigns[indexActividad].name;
            alumnos[indexAlumnos].coursemodule = this.state.data.data.submissionsState.actividades.assigns[indexActividad].coursemodule;
            alumnos[indexAlumnos].url_id = 'https://'+this.props.nivel+'.ieu.edu.mx/mod/assign/view.php?id='+ this.state.data.data.submissionsState.actividades.assigns[indexActividad].coursemodule +'&rownum=0&action=grader&userid=' + alumnos[indexAlumnos].idMoodle ;
          }
        }
        count++;
      }
    }

    let alumnosFiltrados = [];
    let count = 0;
    if (this.state.data.data.submissionsState.filtro) {
      for (let indexAlumno in alumnos) {
        if ((this.state.data.data.submissionsState.filtro[0].actividad === alumnos[indexAlumno].actividadName) && (this.state.data.data.submissionsState.filtro[0].status === alumnos[indexAlumno].status)) {
          alumnosFiltrados.push(alumnos[indexAlumno]);
          count++
        }
      } 
      this.setState({alumnosTabla: alumnosFiltrados, isLoading: false});
    } else {
      this.setState({alumnosTabla: alumnos, isLoading: false});
    }
  }

  render () {
    return(
      <>
      <Dimmer loader active={this.state.isLoading}>
        <MaterialTable
          title=""
          icons={{
            FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
            LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
            NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
            PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
            ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
            Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
            SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
          }}
          columns={[
            { title: 'Matricula', field: 'id', render: rowData => <a href={rowData.url_id} target="_blank">{rowData.id}</a>  },
            { title: 'Nombres', field: 'nombres' },
            { title: 'Apellidos', field: 'apellidos' },
            { title: 'Correo', field: 'correo' },
            { title: 'Actividad', field: 'actividad' },
            { title: 'Status', field: 'status' },
          ]}
          data={this.state.alumnosTabla}
          options={{
              headerStyle: {
              borderBottom: '2px solid #FF6F00',
            },
            rowStyle: {
              backgroundColor: '#f7f7f7',
            },
            draggable: false,
            pageSize: 5,
            pageSizeOptions: [0],
          }}
          localization={{
            body: {
              emptyDataSourceMessage: 'Sin resultados'
            },
            toolbar: {
              searchTooltip: 'Buscar',
              searchPlaceholder: 'Buscar...',
              nRowsSelected: '{0} fila(s) seleccionada(s)'
            },
            pagination: {
              labelRowsSelect: 'filas',
              labelDisplayedRows: '{count} de {from}-{to}',
              firstTooltip: 'Primera página',
              previousTooltip: 'Página anterior',
              nextTooltip: 'Próxima página',
              lastTooltip: 'Última página'
            }
          }}
        />
      </Dimmer>
      </>
    );
  }
}

export default TablaResultados;